import styled from "styled-components";
import Button from "~/components/ui/Button";
import { getColor, getSize } from "~/helpers/style";

export const SVGContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${getSize(1.5)};
  height: ${getSize(1.5)};
  border-radius: 0;
  flex-shrink: 0;

  transition:
    border-radius 300ms ease-out,
    background-color 300ms ease-out,
    background-color ${getColor("white")};
`;

export const BaseButton = styled(Button)`
  &:hover ${SVGContainer} {
    border-radius: 50%;
    background-color: ${getColor("primaryLight")};
    color: ${getColor("primaryLight")};
  }
`;

export const ClearButton = styled(BaseButton)`
  background-color: ${getColor("white")};
  color: ${getColor("textSecondary")};
  border: ${getColor("border")};
  padding: 5px 10px;

  &:hover &:focus {
    background-color: ${getColor("white")};
    font-weight: 600;
  }
`;

export const FilterBadge = styled(BaseButton)`
  border-radius: ${getSize(0.5)};
  border: 1px solid ${getColor("border")};
  background-color: ${getColor("transparent")};
  padding: ${getSize(0.35)} ${getSize(0.65)};
  font-size: ${getSize(1.3)};
  line-height: 1.33;
  color: ${getColor("textSecondary")};
  transition: 300ms ease-out;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  gap: ${getSize(0.5)};
  max-width: 200px;
  overflow: hidden;

  &:hover,
  &:focus {
    background-color: ${getColor("transparent")};
    font-weight: 600;
  }
`;

export const BadgeText = styled.span`
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
`;
